import { render } from "./BancaDati.vue?vue&type=template&id=09e318e0"
import script from "./BancaDati.vue?vue&type=script&lang=ts"
export * from "./BancaDati.vue?vue&type=script&lang=ts"
script.render = render

export default script